<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :header="null"
    @cancel="closeModal"
    width="70rem"
    :wrapClassName="'act-now-contact-modal' + (visibleActNowChatAiModal ? ' act-now-chat-ai-modal' : '')"
  >
    <div class="act-now-contact-container">
      <div class="act-now-contact-container__header">
        <template v-if="visibleActNowChatAiModal">
          <a-button class="act-now-contact-container__header--arrow-back" @click="resetActNowChatModule()">
            <img
              src="@/assets/icons/left-arrow-icon.png"
              alt="icon"
            />
          </a-button>
        </template>
        <h1 class="act-now-contact-container__header--title">
          {{ 'Act Now' }}
        </h1>
      </div>
    </div>
    <div v-if="!visibleActNowChatAiModal" class="act-now-contact-container">
      <a-row :gutter="[16, 16]" class="skeleton-row" v-if="fetchingAuthorities">
        <a-col
          v-for="index in 4"
          :key="index"
          :xs="24"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="12"
        >
        <a-skeleton
          active
          class="act-now-contact-container__card-skeleton" 
          :title="{ width: '100%' }"
          :paragraph="null" 
        >
        </a-skeleton>
        </a-col>
      </a-row>

      <template v-else-if="!fetchingAuthorities && isAnyAuthority">
        <div class="act-now-contact-container__body">
          <div
            v-for="(contacts, category) in actNowAuthorities"
            :key="category"
            class="act-now-contact-container__body--contact-category"
          >
            <template v-if="contacts.length > 0">
              <h2 class="act-now-contact-container__body--contact-category--title">
                {{ category }}
              </h2>
              <a-row :gutter="[16, 16]">
                <a-col
                  v-for="(contact, index) in contacts"
                  :key="index"
                  :xs="24"
                  :sm="12"
                  :md="12"
                  :lg="12"
                  :xl="12"
                >
                  <div class="contact-card" :class="{ selected: contact.selected }">
                    <div class="contact-card__header">
                      <h3>{{ contact.name }}</h3>
                      <a-checkbox v-model:checked="contact.selected" @change="(event) => {addSelectedAuthorities(event, contact)}" />
                    </div>
                    <div class="contact-card__body">
                      <div
                        class="contact-card__body--contact-field"
                        v-if="contact.phone"
                      >
                        <img
                          src="@/assets/icons/telephone-icon.png"
                          alt="Phone"
                          class="icon telephone-icon"
                        />
                        <p>{{ contact.phone }}</p>
                        <button
                          class="copy-btn"
                          @click="
                            copyToClipboard(contact.phone, category, index, 'phone')
                          "
                        >
                          <img src="@/assets/icons/copy-icon.png" alt="Copy" />
                          <div
                            class="copied"
                            v-if="copiedStates[`${category}-${index}-phone`]"
                          >
                            <p>Copied!</p>
                          </div>
                        </button>
                      </div>

                      <div
                        class="contact-card__body--contact-field"
                        v-if="contact.email"
                      >
                        <img
                          src="@/assets/icons/email-icon.png"
                          alt="Email"
                          class="icon"
                        />
                        <p>{{ contact.email }}</p>
                        <button
                          class="copy-btn"
                          @click="
                            copyToClipboard(contact.email, category, index, 'email')
                          "
                        >
                          <img src="@/assets/icons/copy-icon.png" alt="Copy" />
                          <div
                            class="copied"
                            v-if="copiedStates[`${category}-${index}-email`]"
                          >
                            <p>Copied</p>
                          </div>
                        </button>
                      </div>

                      <div
                        class="contact-card__body--contact-field"
                        v-if="contact.address"
                      >
                        <img
                          src="@/assets/icons/address-icon.png"
                          alt="Address"
                          class="icon"
                        />
                        <p>{{ contact.address }}</p>
                      </div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </template>
          </div>
        </div>
      </template>
      <template v-else-if="!fetchingAuthorities && !isAnyAuthority">
        <p class="act-now-contact-container__message">No Authorities found</p>
      </template>
      <div class="act-now-contact-container__footer">
        <a-button
          @click="chatAi('criticize')"
          :loading="generateCriticizeLetterLoader"
          :disabled="actNowSelectedAuthorities.length <= 0"
          :class="{ disabled: actNowSelectedAuthorities.length <= 0 }"
        >
          Generate Example Letter Of Criticism
        </a-button>
        <a-button
          @click="chatAi('praise')"
          :loading="generatePraiseLetterLoader"
          :disabled="actNowSelectedAuthorities.length <= 0"
          :class="{ disabled: actNowSelectedAuthorities.length <= 0 }"
        >
          Generate Example Letter Of Praise
        </a-button>
      </div>
    </div>

    <ActNowChatAi
      v-else
      ref="chatAiRef"
      :visible="visibleActNowChatAiModal"
      :articleId="articleId"
    />

  </a-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ActNowChatAi from "./ActNowChatAi.vue";

export default {
  props: {
    visible: Boolean,
    regionTitle: {
      type: String,
      default: "Pakistan",
    },
    articleId:{
      type:String,
      default: () => (''),
      required: true
    }
  },
  components: {
    ActNowChatAi,
  },
  data() {
    return {
      visibleActNowChatAiModal: false,
      copiedStates: {},
      generateCriticizeLetterLoader: false,
      generatePraiseLetterLoader: false,
      fetchingAuthorities: false
    };
  },
  watch:{
    visible:{
      handler(isVisible){
          if (isVisible){
            (async()=>{
              try{
                this.fetchingAuthorities = true
                this.initiateActNowSocket({articleId: this.articleId})
                await this.fetchActNowAuthorities({articleId: this.articleId})
              }
              catch(err){
                console.log(err)
              }finally{
                this.fetchingAuthorities = false
              }
            })();
          }
      }, immediate:true
    }
  },
  computed:{
    ...mapGetters({
      actNowAuthorities: 'discover/actNowAuthorities',
      actNowSelectedAuthorities: 'discover/actNowSelectedAuthorities'
    }),
    isAnyAuthority(){
      return Object.values(this.actNowAuthorities).some(authority=>authority.length > 0)
    }
  },
  methods: {
    ...mapActions({
      pushActNowAuthorities: 'discover/pushActNowAuthorities',
      generateLetterForOfficials: 'discover/generateLetterForOfficials',
      emptyActNowAuthorities: 'discover/emptyActNowAuthorities',
      fetchActNowAuthorities: 'discover/fetchActNowAuthorities',
      resetSelectedAuthorities: 'discover/resetSelectedAuthorities',
      popActNowAuthorities: 'discover/popActNowAuthorities',
      fetchActNowChat: 'discover/fetchActNowChat',
      initiateActNowSocket: 'discover/initiateActNowSocket',
      closeActNowSocket: 'discover/closeActNowSocket',
      emptyActNowChat: 'discover/emptyActNowChat',
      setActNowChatResponseLoader: 'discover/setActNowChatResponseLoader',
      setLetterType: 'discover/setLetterType'
    }),
    closeModal() {
      this.$emit("handle-close", false);
      this.selected = false;
      this.fetchingAuthorities = false
      this.visibleActNowChatAiModal = false
      this.emptyActNowAuthorities()
      this.resetSelectedAuthorities()
      this.closeActNowSocket()
      this.emptyActNowChat()
    },
    copyToClipboard(text, category, index, fieldType) {
      const key = `${category}-${index}-${fieldType}`;

      // Set this specific field as copied
      this.copiedStates[key] = true;
      setTimeout(() => {
        this.copiedStates[key] = false;
      }, 2000);

      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.copiedStates[key] = true;
          setTimeout(() => {
            this.copiedStates[key] = false;
          }, 2000);
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
        });
    },
    async chatAi(letterType='criticize') {
      try{
        letterType === 'criticize' ? this.generateCriticizeLetterLoader = true : this.generatePraiseLetterLoader = true
        this.setLetterType(letterType)
        await this.generateLetterForOfficials({articleId:this.articleId})
        await this.fetchActNowChat({articleId: this.articleId})
        this.visibleActNowChatAiModal = true;
      }
      catch(err){
        console.log("ERROR",err)
      }finally{
        this.generateCriticizeLetterLoader = false
        this.generatePraiseLetterLoader = false
      }
    },
    addSelectedAuthorities(event, authority){
      if (event.target.checked)
        this.pushActNowAuthorities(authority)
      else
        this.popActNowAuthorities(authority?.id)
    },
    resetActNowChatModule(){
      this.visibleActNowChatAiModal = false
      this.emptyActNowChat()
      this.setActNowChatResponseLoader(false)
    }
  },
};
</script>

<style lang="scss">
.act-now-contact-modal {
  .ant-modal {
    top: 8rem;
    padding-bottom: 0;
    .ant-modal-content {
      padding: 0;
      background-color: rgb(246, 248, 255);

      .ant-modal-close {
        margin: 2rem 2rem 0 0;
        .ant-modal-close-x {
          .anticon {
            font-size: 2rem;
            @include respond(phone-large) {
              font-size: 3rem;
            }
          }
        }
      }

      .ant-modal-body {
        .act-now-contact-container {
          .skeleton-row {
            padding: 6rem 1.7rem;
            margin: 0 !important;
          }
          &__card-skeleton {
            .ant-skeleton-content {
              .ant-skeleton-title {
                margin: 0;
                height: 10rem;
              }
            }
          }
          &__message {
            font-size: 1.8rem;
            line-height: normal;
            color: $color-black;
            text-align: center;
            padding: 2.5rem;
            font-family: $font-primary;
            margin: 0;
            min-height: 24rem;
            display: flex;
            align-items: center;
            justify-content: center;
            @include respond(phone-large) {
              font-size: 2.5rem;
              padding: 3rem;
            }
          }
          &__header {
            padding: 2.5rem 2.5rem 0;
            display: flex;
            align-items: center;
            gap: 1rem;
            &--arrow-back {
              width: max-content;
              height: max-content;
              line-height: normal;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              border: none;
              outline: none;
              box-shadow: none;
              background-color: transparent;
              padding: 0 !important;
              margin: 0;
              cursor: pointer;
              img {
                width: 2.8rem;
                height: auto;
              }
              @include respond(phone-large) {
                img {
                  width: 4rem;
                }
              }
            }
            &--title {
              font-size: 2.5rem;
              font-family: $font-primary-bold;
              color: $color-black;
              margin-bottom: 0;
              line-height: normal;
              @include respond(phone-large) {
                font-size: 3.2rem;
              }
            }
          }

          &__body {
            margin-top: 2rem;
            padding: 0 2.5rem;
            max-height: calc(100vh - 32rem);
            overflow-y: auto;
            overflow-x: hidden;
            @include respond(phone-large) {
              max-height: calc(100vh - 56rem);
            }
            &--contact-category {
              margin-bottom: 2rem;
              @include respond(phone-large) {
                margin-bottom: 3rem;
              }
              &--title {
                font-size: 2rem;
                font-family: $font-primary-medium;
                color: $color-black;
                margin-bottom: 1rem;
                line-height: normal;
                @include respond(phone-large) {
                  font-size: 2.8rem;
                  margin-bottom: 2rem;
                }
              }

              .contact-card {
                border: 1px solid $color-dark-grey-5;
                background-color: $color-white;
                border-radius: 1rem;
                transition: box-shadow 0.3s;
                height: 100%;
                
                &.selected {
                  box-shadow: 0 0 0 1px $color-primary;
                }

                &__header {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 1.2rem 1.5rem 1rem;
                  position: relative;
                  @include respond(phone-large) {
                    padding: 1.6rem 1.5rem 1.4rem;
                  }

                  &::before {
                    content: "";
                    height: 2px;
                    width: 92%;
                    position: absolute;
                    bottom: -0.2rem;
                    right: 4%;
                    background-color: #cdcdcd6b;
                  }

                  h3 {
                    font-size: 1.6rem;
                    font-family: $font-primary-medium;
                    color: $color-black;
                    margin-bottom: 0;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1; /* number of lines to show */
                            line-clamp: 1; 
                    -webkit-box-orient: vertical;
                    @include respond(phone-large) {
                      font-size: 2.2rem;
                    }
                  }

                  .ant-checkbox-wrapper {
                    .ant-checkbox {
                      .ant-checkbox-inner {
                        height: 1.6rem;
                        width: 1.6rem;
                        border: 1px solid $color-dark-grey-4;
                        &::after {
                          width: 0.6rem;
                          height: 0.9rem;
                        }
                        @include respond(phone-large) {
                          width: 2.6rem;
                          height: 2.6rem;
                          &::after {
                            width: 1rem;
                            height: 1.5rem;
                          }
                        }
                      }
                    }
                  }
                  .ant-checkbox-wrapper-checked {
                    .ant-checkbox-checked {
                      .ant-checkbox-inner {
                        height: 1.6rem;
                        width: 1.6rem;
                        background-color: $color-primary;
                        border-color: $color-primary;
                        @include respond(phone-large) {
                          width: 2.6rem;
                          height: 2.6rem;
                        }
                      }
                    }
                  }
                }

                &__body {
                  padding: 1.5rem;
                  display: flex;
                  flex-direction: column;
                  gap: 1rem;
                  @include respond(phone-large) {
                    gap: 1.6rem;
                  }
                  &--contact-field {
                    display: flex;
                    align-items: center;
                    gap: 0.7rem;
                    p {
                      font-size: 1.4rem;
                      font-family: $font-primary;
                      color: $color-black;
                      line-height: 2rem;
                      margin-bottom: 0;
                      opacity: 0.7;
                      display: flex;
                      align-items: center;
                      gap: 0.7rem;
                      overflow: hidden;
                      display: -webkit-box;
                      -webkit-line-clamp: 1; /* number of lines to show */
                              line-clamp: 1; 
                      -webkit-box-orient: vertical;
                    }
                    .icon {
                      width: 1.6rem;
                      height: auto;
                    }
                    .telephone-icon {
                      width: 1.5rem;
                    }

                    .copy-btn {
                      border: none;
                      outline: none;
                      border-radius: 0.5rem;
                      width: 2rem;
                      height: 2rem;
                      background-color: #8080803d;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                      margin-left: 0.3rem;
                      position: relative;
                      img {
                        width: 1rem;
                        height: auto;
                      }
                      .copied {
                        position: absolute;
                        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
                        bottom: 0;
                        padding: 0.5rem 1rem;
                        border-radius: 0.5rem;
                        z-index: 1;
                        background-color: $color-white;
                        right: -6rem;
                        p {
                          font-size: 1rem;
                          font-family: $font-primary;
                          margin-bottom: 0;
                          line-height: normal;
                        }
                      }
                    }
                    @include respond(phone-large) {
                      gap: 1rem;
                      p {
                        font-size: 2.2rem;
                      }
                      .icon {
                        width: 2.7rem !important;
                      }
                      .telephone-icon {
                        width: 2.4rem !important;
                      }
                      .copy-btn {
                        width: 3.5rem;
                        height: 3.5rem;
                        img {
                          width: 1.8rem;
                        }
                        .copied {
                          right: -9rem;
                          bottom: 0.4rem;
                          p {
                            font-size: 1.8rem;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            &::-webkit-scrollbar {
              width: 0.4rem;
              height: 0.4rem;
            }

            &::-webkit-scrollbar-track {
              background-color: transparent;
              border-radius: 0.8rem;
            }

            &::-webkit-scrollbar-thumb {
              background-color: $color-primary;
              border-radius: 0.8rem;
            }
          }

          &__footer {
            display: grid;
            grid-template-columns: 1fr 1fr;
            align-items: center;
            justify-content: space-between;
            gap: 1.5rem;
            padding: 2.5rem;
            @include respond(phone-large) {
              grid-template-columns: 1fr;
            }
            .ant-btn {
              width: 100%;
              background-color: $color-primary;
              border: none;
              outline: none;
              height: auto;
              font-size: 1.5rem;
              font-family: $font-primary-medium !important;
              color: $color-white;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0 1.5rem;
              white-space: inherit;
              height: 4.4rem;
              span {
                line-height: 2rem;
                display: inline;
                width: max-content;
              }

              .anticon {
                .anticon-spin {
                  font-size: 2rem;
                  color: $color-primary;
                }
              }
              @include respond(phone-large) {
                font-size: 2.2rem;
                padding: 0 2rem;
                height: 5.6rem;
                .anticon {
                  .anticon-spin {
                    font-size: 2.6rem;
                  }
                }
              }

              &:hover,
              &:focus {
                background-color: $color-primary;
                color: $color-white;
              }
            }
            .disabled {
              cursor: not-allowed;
              pointer-events: none; // optional: disables all interactions
              opacity: 0.5;
            }
          }
        }
      }
    }
  }
}
.act-now-chat-ai-modal {
  .ant-modal {
    .ant-modal-content {
      background-color: $color-white;
    }
  }
}
</style>
